import { useLDClient } from 'launchdarkly-react-client-sdk';

export function useFeatureFlag<T>(name: string, defaultValue?: T): T {
  const ldClient = useLDClient();
  return ldClient?.variation(name, defaultValue);
}
